import { NavLink, type NavLinkProps } from "react-router-dom";

export function TabNavLink(props: NavLinkProps) {
  const { children, ...rest } = props;
  return (
    <div>
      <div className="no-focus">
        <NavLink
          {...rest}
          className={({ isActive }) =>
            `no-underline group text-left flex items-center gap-2 w-full p-3 lg:rounded ${
              isActive
                ? "font-semibold bg-r8-gray-12 text-r8-gray-1 hover:bg-r8-gray-12"
                : "hover:bg-r8-gray-3"
            }`
          }
        >
          {children}
        </NavLink>
      </div>
      <div className="px-3 py-1.5" data-toc={props.to} />
    </div>
  );
}
